import React, { ReactNode } from 'react'

import Checkbox from 'components_new/atoms/Checkbox'
import Box from 'components_new/atoms/Box'
import FormControlLabel from 'components_new/atoms/FormControlLabel'
import Icon, { IconProps } from 'components_new/atoms/Icon'
import Text from 'components_new/atoms/Text'

interface CheckboxItemProps {
  checked: boolean
  disabled?: boolean
  // If true, the label is rendered as it is passed without an
  // additional text node:
  disableText?: boolean
  endIcon?: Omit<IconProps, 'color' | 'sx'>
  fullWidth?: boolean
  hover?: boolean
  label: ReactNode
  onChange?: () => void
  size?: 'small' | 'medium'
  sx?: object
  TextProps?: object
}

const CheckboxItem = (props: CheckboxItemProps) => {
  const {
    checked,
    disabled,
    disableText,
    endIcon,
    fullWidth,
    hover,
    label,
    onChange,
    size,
    sx,
    TextProps
  } = props

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          size={size}
        />
      }
      disableTypography={disableText}
      label={
        endIcon ? (
          <Box
            component="span"
            sx={{ display: 'flex', flex: 1, justifyContent: 'space-between' }}
          >
            <Text
              {...TextProps}
              component="span"
              sx={{ 'label:hover &': { color: 'text.primary' } }}
            >
              {label}
            </Text>
            <Icon
              color="disabled"
              sx={{ mr: 1, opacity: 0, 'label:hover &': { opacity: 1 } }}
              {...endIcon}
            />
          </Box>
        ) : (
          label
        )
      }
      labelPlacement="end"
      slotProps={{
        typography: {
          ...TextProps,
          sx: { 'label:hover &': { color: 'text.primary' } }
        }
      }}
      sx={{
        mx: 0,
        width: fullWidth ? '100%' : undefined,
        ...sx,
        ['&:hover']: {
          bgcolor: hover ? 'action.hover' : undefined
        }
      }}
    />
  )
}

export default CheckboxItem
